import { useState } from "react";
import { motion } from "framer-motion";
import { FiMail, FiUser, FiMessageCircle, FiPhone, FiMapPin } from "react-icons/fi";

export default function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("submitting");
    try {
      await new Promise((res) => setTimeout(res, 1500));
      setStatus("success");
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="bg-primary text-text-light py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-primary-light/20 p-10 rounded-3xl shadow-xl backdrop-blur border border-accent-soft"
        >
          <h2 className="text-3xl font-bold text-accent mb-8">Contact MJR Holdings</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            {[{ name: "name", placeholder: "Your Name", icon: <FiUser /> },
              { name: "email", placeholder: "Your Email", icon: <FiMail />, type: "email" },
              { name: "subject", placeholder: "Subject", icon: <FiMessageCircle /> },
            ].map(({ name, placeholder, icon, type = "text" }) => (
              <div key={name} className="relative">
                <input
                  type={type}
                  name={name}
                  placeholder={placeholder}
                  value={formData[name]}
                  onChange={handleChange}
                  required
                  className="w-full p-4 pl-12 rounded-lg bg-white/10 text-text-light placeholder-accent-dark focus:ring-2 focus:ring-accent outline-none"
                />
                <span className="absolute top-4 left-4 text-accent">{icon}</span>
              </div>
            ))}

            <div className="relative">
              <textarea
                name="message"
                rows="5"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full p-4 pl-12 rounded-lg bg-white/10 text-text-light placeholder-accent-dark focus:ring-2 focus:ring-accent outline-none"
              />
              <span className="absolute top-4 left-4 text-accent">
                <FiMessageCircle />
              </span>
            </div>

            <button
              type="submit"
              disabled={status === "submitting"}
              className="w-full py-3 bg-accent text-primary font-bold rounded-full hover:brightness-110 transition"
            >
              {status === "submitting" ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <p className="text-green-400 text-sm mt-2 text-center">✅ Message sent successfully!</p>
            )}
            {status === "error" && (
              <p className="text-red-400 text-sm mt-2 text-center">❌ Something went wrong. Try again.</p>
            )}
          </form>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="space-y-8"
        >
          <div className="space-y-3">
            <h3 className="text-2xl font-bold text-accent">Get In Touch</h3>
            <p className="flex items-center gap-3 text-primary-light">
              <FiMapPin className="text-accent" />
              4 Haakdoring Street, West Acres, Mbombela, 1200
            </p>
            <p className="flex items-center gap-3 text-primary-light">
              <FiPhone className="text-accent" />
              068 641 5955 | 071 122 3651 | 060 680 8999
            </p>
            <p className="flex items-center gap-3 text-primary-light">
              <FiMail className="text-accent" />
              admin@mjrholdings.co.za
            </p>
          </div>

          <iframe
            title="MJR Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3582.4737346880215!2d30.981789175409355!3d-25.470590677536105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ee8378ac1fbcbe9%3A0x25903dc6b45d8f3b!2s4%20Haakdoring%20St%2C%20West%20Acres%2C%20Mbombela%2C%201200!5e0!3m2!1sen!2sza!4v1683123123123"
            className="w-full h-64 rounded-xl border-2 border-accent"
            loading="lazy"
          ></iframe>
        </motion.div>
      </div>
    </section>
  );
}
